import "./App.scss";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./component/Homepage";
import Layout from "./component/layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SolutionDetails from "./component/Solutionpage";
import About from "./component/Aboutpage";
import Contact from "./component/Contactpage";
import Career from "./component/Carrierpage";
import ScrollToTopOnRouteChange from "./utility/ScrollToTopChange";
import PageNotFound from "./component/PageNotFound";
import PrivacyPolicy from "./component/Privacypolicy";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 120,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <Router>
      <ScrollToTopOnRouteChange/>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/solution/:name" element={<SolutionDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        </Route>
        <Route path="*" element={<PageNotFound/>}/>
      </Routes>
    </Router>
  );
}

export default App;
